<ng-template [ngIf]="subscriptionType === 'onetime'">
  <div class="p-6 px-md-12 py-md-4 rounded border bg-black pulse mx-0 mx-md-10 mb-9">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center">
      <p class="mb-0 text-center text-md-start mb-4 mb-md-0 text-white">
        Oops, no solution coins left for new tasks.
      </p>
      <button
        type="button"
        (click)="continueClick()"
        class="btn btn-outline border-2 app-btn-yellow px-md-15"
      >
        Get More Coins
      </button>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="subscriptionType === 'regular'">
  <div class="p-6 px-md-12 py-md-4 rounded bg-primwhite border shadow mx-0 mx-md-10 mb-9">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center">
      <div class="d-flex align-items-center mb-5 mb-md-0">
        <div class="me-4 me-md-7">
          <div class="rounded-2 border border-2 border-primgreen px-5 py-4 mb-2">
            <p class="mb-0 fs-4 text-primblack fw-bold">
              {{(hours.toString().length < 2) ? '0' + hours : hours}}:{{(minutes.toString().length < 2) ? '0' + minutes : minutes}}:{{(seconds.toString().length < 2) ? '0' + seconds : seconds}}
            </p>
          </div>
          <p class="small text-center mb-0 text-primblack">
            <small>
              Till FREE coin top&#8209;up
            </small>
          </p>
        </div>
        <div>
          <p class="text-primblack mb-0 fw-bold fs-4">
            No solution coins left. Free coins soon.
          </p>
          <p class="mb-0 fs-6">
            Get more coins now or wait till
            <span class="text-primblack fw-bold">
              FREE
            </span>
            daily coin top&#8209;up.
          </p>
        </div>
      </div>
      <button
        type="button"
        (click)="continueClick()"
        class="btn btn-outline border-2 app-btn-yellow px-md-15"
      >
        Get More Coins
      </button>
    </div>
  </div>
</ng-template>
